import React, { useEffect, useState } from 'react'
import { Card, Col, Container, Image, Row } from 'react-bootstrap'
import { Link, withRouter } from 'react-router-dom'
import { HiLocationMarker } from 'react-icons/hi';
import { BiTimeFive } from 'react-icons/bi';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { useLocation } from "react-router-dom";
import { getList, post } from '../helpers/api_helper';
import HTMLRenderer from 'react-html-renderer'
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Loader from '../components/Loader/Loader';


function JobDescription(props) {
    const { user } = props;
    const location = useLocation();
    const [jobdes, setJobdes] = useState('');
    const [data, setData] = useState(null);
    const [opporId, setOpporId] = useState(null);
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        if (location?.pathname) {
            let url = location?.pathname;
            let id = url.split("/")[2];
            console.log('param on job description', id);
            if (id)
                setOpporId(id);
        }
    }, [props]);

    useEffect(() => {
        if (opporId)
            getDescription(opporId);
    }, [opporId]);

    const getDescription = (id) => {
        setLoader(true);
        // console.log('iiiiii',id)
        getList(`/oppor/detail?opporId=${id}`).then((json) => {
            // console.log('response des', json);
            if (json.statusCode == 200) {
                setLoader(false);
                setJobdes(json.data?.desc);
                setData(json.data);

            } else {
                setLoader(false);
            }

        })

    }

    const applyFunction = (id) => {

        if (props?.user) {
            const body = {
                opporId: id,
                userId: user?._id,
                token: user?.token
            }
            post('/oppor/apply', body).then((json) => {
                //    console.log('apply dada function',json)
                if (json.statusCode == 200) {
                    toast.success(json.message);
                    getDescription(id);
                }

            })
                .catch((error => {
                    // console.log(error);
                    toast.error(error)
                }))
        } else {
            props.history.push('/login');
        }

    }


    // console.log('jobdes', jobdes);
    return (
        <>
            {
                loader && <Loader />
            }
            <section className='banner_strip'>
                <h1>Job Description</h1>
            </section>
            <div className='job-page'>
                <Container fluid style={{ padding: 0 }}>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/job-listing">Opportunities</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Job Description</li>
                        </ol>
                    </nav>
                </Container>
                <Container fluid>
                    <AvForm>
                        <Row>
                            <Col lg={8} className="p-1">
                                <div className='company_profile_detail'>
                                    <Card className='opportunities_box'>
                                        <Row>
                                            <Col lg={2} md={12} className="job_box_d">
                                                <div className='company_logo'>
                                                    <Image src={data?.cover} />
                                                </div>
                                            </Col>
                                            <Col lg={7} md={12} className="job_box_d">
                                                <div className='job-title  job-title-d'>
                                                    <h4>{data?.title}</h4>
                                                    <h6>{data?.company[0]?.title}</h6>

                                                    <div className='ch'>
                                                        <p>Position <span className='span-color1'>({data?.vacancy})</span> Location <span className='span-color'>(<span>{data?.location?.length}</span>)</span></p>
                                                        <p className='active_day'><BiTimeFive /> {data?.createdAt}</p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={3} md={12} className="job_box_d">
                                                <div className='action-box action-box-j'>
                                                    <ul>
                                                        <li>
                                                            {
                                                                data?.applicant.findIndex(x => x.userId == user?._id) == -1 ? <a href='javascript:void(0)' className='apply' onClick={() => applyFunction(data._id)}>Apply Now</a> : <a href='javascript:void(0)'>Applied</a>
                                                            }
                                                        </li>


                                                    </ul>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                    <Row>
                                        <Col lg={12}>
                                            <div className='job_desc_b'>
                                                <Col>
                                                    <h3>Job Description</h3>

                                                </Col>
                                                <Col>
                                                    <HTMLRenderer html={jobdes} />
                                                </Col>

                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div>
                                    <Row>
                                        <Col lg={12}>
                                            <Card className='f-card'>
                                                <h5>Job Overview</h5>
                                                <ul className="job-overview list-unstyled">
                                                    <li><strong>Title:</strong> {data?.title}</li>
                                                    <li><strong>Published on:</strong> {data?.createdAt}</li>
                                                    <li><strong>Vacancy:</strong> {data?.vacancy}</li>
                                                    <li><strong>For:</strong> {data?.opporFor}</li>
                                                    <li><strong>Qualification:</strong> {data?.quali?.map((item, index)=> item?.title+", ")}</li>
                                                    <li><strong>Industry:</strong> {data?.industry[0]?.title}</li>
                                                    <li><strong>Company:</strong> {data?.company[0]?.title}</li>
                                                    <li><strong>Course:</strong> {data?.course[0]?.type}</li>
                                                    <li><strong>Skills:</strong> {data?.course[0]?.title}</li>
                                                    <li><strong>Duration:</strong> {data?.course[0]?.duration}</li>
                                                    <li><strong>Application Deadline:</strong> {data?.expireOn}</li>
                                                    <li><strong>Job Location:</strong> {data?.location.map((item) => <span key={item?._id}>{item?.city}, {item?.state}</span>)}</li>
                                                </ul>
                                            </Card>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </AvForm>
                </Container>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    // console.log('123apply', state)
    const { user } = state.Login
    return { user }
}

export default withRouter(
    connect(mapStateToProps, {})(JobDescription)
)